<template>
  <div class="statement">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="statement_body">
        <div class="law" style="margin-top: 105px">
          <h1>奇迹ip隐私协议</h1>
          <div class="lawTab">
            <h3>协议最新更新时间：2025年01月14日</h3>
            <h3>协议生效日期： 2025年01月14日</h3>
            <div class="paneContent">
              <div class="detail-box">
                <div class="tit">特别提示</div>
                <p>感谢您选择和使用奇迹ip服务。</p>
                <p>
                  出于方便您注册、登录并使用奇迹ip相关服务的目的，我们将可能会采集、保存、使用、共享您的信息。奇迹ip非常重视对您的信息保护，我们将根据法律法规要求，采取对应的安全保护措施。我们将通过本《奇迹ip隐私协议》（以下简称“本协议”）来向您解释与说明，在您使用奇迹ip提供的产品、服务时，我们如何收集、使用、保管和共享您的信息，以及我们为您提供的访问、更新、控制和保护这些信息的方法。
                </p>
                <p>
                  除奇迹ip另有说明或与您另有约定外，本隐私协议中的术语涵义与《奇迹ip用户服务协议》中所用术语相同。
                </p>
                <p>
                  <span class="big font"
                    >请您仔细阅读本协议。在您以在线勾选等任何方式确认接受本协议时或您使用奇迹ip服务的，即视为您已充分阅读、理解并同意接受本协议的约束，本协议即在您与奇迹ip之间发生法律效力。</span
                  >
                </p>
                <div class="tit">一、本协议的适用范围</div>
                <p>
                  1.1
                  本协议仅适用于奇迹ip（以下或称“我们”或“奇迹ip”）提供的产品和服务功能（以下简称“服务”）<br /><br />
                  1.2
                  本协议同样适用于因奇迹ip基于产品发展进行升级更新的服务和功能，包括但不限于网站、接口、定制程序以及随技术发展出现衍生产品和服务。<br /><br />
                  1.3
                  本协议适用于您注册、使用奇迹ip时所提交的所有信息、资料，以及奇迹ip为了向您提供服务而收集的信息。<br /><br />
                  1.4
                  本协议不适用于其他第三方提供的产品/服务，比如您通过奇迹ip网站获取、使用第三方提供的产品/服务，上述您与第三方建立的法律关系所需确认的服务协议、使用政策以及其他信息，需您与服务商另行确定。<br /><br />
                  1.5
                  若我们提供的某项产品/服务有单独的隐私政策（包括其对应的各类协议中存在的特别约定），则该产品/服务的隐私政策及特殊约定将优先适用，该产品/服务隐私政策未约定或约定不明且不存在特别约定的，则以本协议内容为准。
                </p>
                <div class="tit">二、我们收集的信息</div>
                <p>
                  2.1 您知晓并同意，我们将会通过以下几种方式收集您的信息：<br />2.1.1
                  在注册奇迹ip账号时，您主动提交的手机号码信息、实名信息，设置、确认登录密码等。<br />2.1.2
                  在特殊情况下，您委托并授权我们的员工或者合作伙伴代您上传、提交的相关信息，例如您委托我们的客服人员填写、上传的您的相应信息。<br />2.1.3
                  您使用我们的服务过程中，我们主动收集的信息，包括但不限于：<br />（1）
                  操作记录，我们会接收并记录您使用奇迹ip服务的操作记录、日志记录及相关信息等。<br />（2）合同信息，如果您需要线下交付等，您应提供联系人、联系方式、地址、开票信息、订单等必要信息。<br /><br />
                  2.2在您进行实名认证时，您需要根据网页提示提供姓名、身份证、手机号、人脸信息等信息。您的账户只有在通过这些认证和验证之后，才能获得使用相关产品/服务的资格，请确认提交合法、真实、有效的信息。<br /><br />
                  2.3若您是通过企业名义注册奇迹ip，则在进行实名认证时，您需向我们提交您的企业名称、统一社会信用代码、营业执照扫描件或照片、银行账号信息（包括开户行、银行账号和开户人），以及对公转账截图，我们将根据您提交的信息验证身份。<br /><br />
                  2.4
                  如果您需要加入推广计划或成为奇迹ip代理商，需另行签署相关协议，为履行合同所必需，您应提供联系人、联系方式等必要信息。<br /><br />
                  2.5
                  您通过我们的客服或参加我们举办的活动时，所签署的合同等材料信息。<br /><br />
                  2.6 其他信息，例如咨询沟通记录。
                </p>
                <p>
                  随着业务的发展，我们提供的产品功能和服务可能会有所调整和变化，若处理目的因此发生变更，我们将再次向您进行说明，并征得您的同意。以上信息我们至少保留6个月以上，所有操作记录均做完整日志记录，6个月后做永久封存。
                </p>
                <div class="tit">三、我们如何使用收集的信息</div>
                <p>
                  为了向您提供优质、便捷、安全的服务，我们将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。
                </p>
                <br />
                <p>
                  3.1 向您提供服务。<br /><br />
                  3.2 实现本协议“我们收集的信息”约定的目的。<br /><br />
                  3.3
                  向您推送产品消息、奇迹ip动态等相关业务消息和商业广告。例如，奇迹ip可以通过您的手机号码、电子邮箱等联系方式以短信、电话、电子邮件等任何方式向您推送商业广告，宣传、推广奇迹ip服务。<br /><br />
                  3.4 邀请您参与有关我们产品和服务的调查。<br /><br />
                  3.5 完善、优化和提高奇迹ip在线服务。<br /><br />
                  3.6 根据法律法规或监管要求向相关部门进行报告。
                </p>
                <div class="tit">四、我们共享、转移以及公开披露的信息</div>
                <p>
                  我们仅在您明确授权/同意的前提下，遵守相关法律法规，在合法、正当、必要的范围内共享、转让、公开披露、委托处理您的信息。
                </p>
                <p>
                  <span class="big font">4.1 共享</span
                  ><br />为了向您提供更完善、优质的产品/服务，我们可能将您的信息与我们的第三方合作伙伴共享。此时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理您的个人信息。除法律法规规定以及奇迹ip与您另有约定外，未经您同意，我们不会与任何无关第三方共享您的信息。<br />如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方服务。通常我们的合作伙伴有如下几类：<br />4.1.1
                  为我们的产品/服务提供功能支持的服务提供商：例如提供支付服务的支付机构（支付宝、微信、公户转账）、提供实名认证功能的验证机构。<br />4.1.2
                  信息推广和广告投放的合作伙伴：您确认我们有权与信息推广和广告投放的合作伙伴共享我们使用您的相关信息，集合形成的间接用户画像、去标识化或匿名化处理后的分析/统计类信息以及去标识化的用户设备识别码，以帮助其进行广告或决策建议、提高广告有效触达率、进一步了解用户需求。<br />我们承诺：未经您的同意，我们不会与其共享可以识别您身份的个人信息。<br /><span
                    class="big font"
                    >4.2 转让</span
                  ><br />除获取您的明示同意外，我们不会将您的个人信息转让给任何公司、组织或个人。随着我们业务的持续发展，我们有可能进行分立、合并、收购、资产转让或类似的交易，您的信息有可能作为此类交易的一部分而被转移。我们会向您告知接收方的名称或者姓名，并要求接收方继续受本隐私政策的约束。如接收方变更本隐私政策中约定的个人信息处理目的、处理方式，我们将要求接收方重新获取您的授权同意。<br /><span
                    class="big font"
                    >4.3 信息披露</span
                  ><br />除符合法律法规的规定进行公开披露或以下情形外，我们不会公开披露您未自行公开或者其他未合法公开的个人信息。以下情形除外。<br />4.3.1
                  经您事先同意，向第三方披露。<br />4.3.2
                  如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。<br />4.3.3
                  根据法律的有关规定，或者行政或司法机关的要求，向第三方或者行政、司法机关披露。<br />4.3.4如您出现违反中国有关法律、法规或者奇迹ip服务协议或相关规则的情况，需要向第三方披露。<br />4.3.5为提供您所要求的产品和服务，而必须和第三方分享您的个人信息。<br />4.3.6
                  在奇迹ip的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，奇迹ip有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。<br />4.3.7
                  其它奇迹ip根据法律、法规或者网站政策认为合适的披露。<br /><span
                    class="big font"
                    >4.4.共享、转让、公开披露您的个人信息的例外</span
                  ><br />根据相关法律等规定，在以下情形中，我们可以不经您同意而共享、转让、公开披露您的信息：<br />4.4.1
                  提供“二、我们收集的信息”中的相应功能或服务所必需，以及出于“三、我们如何使用收集的信息”中的部分所述目的所必需。<br />4.4.2
                  履行我们在《奇迹ip用户服务协议》或本协议中的义务、行使我们的权利。<br />4.4.3
                  为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务。<br />4.4.4
                  为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需。<br />4.4.5
                  为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息。<br />4.4.6
                  用户自行向社会公众公开的个人信息。<br />4.4.7
                  从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                </p>
                <div class="tit">五、我们如何使用 Cookie 及相关技术</div>
                <p>
                  在您使用我们的产品/服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，例如您访问网站的习惯、浏览信息、登录信息等，我们使用
                  Cookie 的具体用途包括：
                </p>
                <br />
                <p>
                  5.1
                  记住您的身份。例如：Cookie帮助我们辨认您作为我们的注册用户的身份，省去为使用我们服务而重复输入账号的步骤。<br /><br />
                  5.2
                  分析您使用我们服务的情况，了解您使用我们服务的具体用途、哪些网页或服务最受您的欢迎，以便为您提供更加周到的个性化服务。<br /><br />
                  5.3 您可以通过浏览器设置拒绝或管理 Cookie。但请注意，如果停用
                  Cookie，您有可能将无法正常使用我们的相关产品/服务或无法通过我们的产品/服务获得最佳的服务体验，某些功能的可用性可能会受到影响。<br /><br />
                  5.4本协议将同样适用于通过奇迹ip Cookie 记录的有关信息。
                </p>
                <div class="tit">六、信息存储地点和期限</div>
                <p>
                  6.1我们会采取合理可行的措施，避免收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非受到法律的允许。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。<br />但在下列情况下，我们有可能需要较长时间保留您的信息或部分信息：
                </p>
                <p>
                  6.1.1 根据法律法规等有关规定我们应该长期保存。<br />6.1.2
                  法院生效判决、裁定或其他法律程序的要求我们长期保存<br />6.1.3
                  行政、司法机关或其他有权机关要求我们长期保存。<br />6.1.4
                  为执行相关服务协议或本隐私协议、处理投诉/纠纷，或者是保护社会利益以及他人的人身和财产安全或其他合法权益所必需的。
                </p>
                <div class="tit">七、信息安全</div>
                <p>
                  7.1
                  为防止防信息的丢失、不当使用、未经授权阅览或披露，我们将努力使用以下安全技术及措施以保障您的用户信息：<br />7.1.1我们采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。<br />7.1.2
                  我们建立严格的管理制度和流程来确保信息的安全。例如，我们严格限制访问信息的人员范围，只有授权人员才可访问用户信息,并要求相关人员遵守保密义务。<br />7.1.3
                  若不幸发生用户信息安全事件（泄露、丢失等），我们会以发送电子邮件、推送通知、公告等形式及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。同时，我们还将按照监管部门要求，上报用户信息安全事件的处置情况。<br /><br />
                  7.2
                  为了更好地保护您的信息安全，我们建议您加强自我保护意识和措施。请您妥善保管自己的信息，避免泄露。我们仅在因奇迹ip过错直接导致您信息泄露的范围内承担责任。
                </p>
                <div class="tit">八、您如何管理自己的信息</div>
                <p>
                  在您使用我们服务的过程中，您可以访问、修改您的用户信息。我们将依照法律法规要求或双方约定收集、使用和存储您的信息。
                </p>
                <div class="tit">九、协议的变更</div>
                <p>
                  9.1由于政策变化、业务调整、技术和服务的变更等原因，我们保留对本协议条款进行修订的权利，该等修订构成本协议的一部分。我们将在更新后的本隐私协议生效前通过官网发布等方式通知您。通知后您继续使用我们服务对，即表示您同意接受修订后的内容。我们不会削减您按照本协议所应享有的权利，除非经过您明确同意。如果前述修订可能造成您在本协议下的权利的实质性减少或重大变更，我们会再次征求您的明示同意。<br /><br />
                  9.2 重大变更包括但不限于：<br />
                  9.2.1
                  我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。<br />
                  9.2.2
                  我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等。<br />
                  9.2.3个人信息共享、转让或公开披露的主要对象发生变化。<br />
                  9.2.4
                  您参与个人信息处理方面的权利及其行使方式发生重大变化。<br />
                  9.2.5
                  我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；<br />
                  9.2.6 个人信息安全影响评估报告表明存在高风险时。<br />
                </p>
                <div class="tit">十、与我们联系</div>
                <p>
                  如您对本协议或其他相关事宜有疑问，您可以将问题发送至我们的企业邮箱：973274009@qq.com，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以回复。
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <Footer></Footer>
    </el-container>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
export default {
  components: { Head, Footer },
  name: "statement",
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  created() {},
  mounted() {
    this.totop()
  },
};
</script>
<style lang="scss" scoped>
.law {
  padding-bottom: 1rem;
  color: #444a6d;
}
.law h1 {
  width: 100%;
  text-align: center;
  font-size: 40px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 600;
  // margin: 180px 0 0;
  color: #18181b;
}
.law .lawTab {
  max-width: 965px;
  margin: 40px auto 0;
}
.law .lawTab h3 {
  font-size: 21px;
  line-height: 30px;
  color: #18181b;
  font-family: SourceHanSansCN-Medium;
  font-weight: 600;
  text-align: left;
}
.detail-box .tit {
  text-align: left;
  font-size: 24px;
  font-family: SourceHanSansCN-Medium;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #18181b;
}
.detail-box p {
  margin: 0;
  font-size: 16px;
  text-align: left;
}
</style>
